import { Button, Form, Modal, Radio, Select } from "antd";
import React from "react";

const ImportConfirmationDialog = ({
  open,
  onCancel,
  onConfirm,
  confirmForm,
  floorOptions,
}) => {
  return (
    <Modal
      title="Are you sure you want to import?"
      open={open}
      onCancel={onCancel}
      zIndex={10000}
      footer={[
        <Button key="back" onClick={onCancel}>
          No
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            onConfirm(confirmForm.getFieldsValue());
          }}
        >
          Yes
        </Button>,
      ]}
    >
      <Form
        form={confirmForm}
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item label="Floor for backgrounds:" name="backgroundFloors">
          <Select
            mode="multiple"
            options={floorOptions}
            placeholder="Select (NEN & perceeltekening excluded)"
            dropdownStyle={{ zIndex: 10000 }}
          />
        </Form.Item>
        <Form.Item
          label="NEN Orientation:"
          name="nenOrientation"
          initialValue="landscape"
        >
          <Radio.Group>
            <Radio.Button value="landscape">Landscape</Radio.Button>
            <Radio.Button value="portrait">Portrait</Radio.Button>
          </Radio.Group>
        </Form.Item>
      </Form>

    </Modal>
  );
};

export default ImportConfirmationDialog;
